// src/components/FormulaDetailPopup.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDate } from "../../utils/dateUtils";

function FormulaDetailPopup({ show, handleClose, item }) {
  // item can be null initially
  if (!item) {
    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Formula Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>No data to show</p>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleClose} centered className="formula_popup">
      <Modal.Header closeButton>
        <Modal.Title>Formula Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h4>{item.name || "Formula"}</h4>

        <div className="detail">
          <h5>
            {item.expression ?? "Health Insurance = (Gross Salary × Rate%)"}
          </h5>
          <p style={{ whiteSpace: "pre-line" }}>
            Example : {"\n" + item.description ?? "Gross Salary × 2%"}
          </p>
        </div>

        <div className="d-flex w-100">
          <div className="w-50">
            <p>Tax Apply</p>
            <h3>{item.taxApply ?? "—"}</h3>
          </div>

          <div className="w-50">
            <p>Created On</p>
            <h3>
              {formatDate(item.createdAt)}
            </h3>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FormulaDetailPopup;
